<template>
  <main class="view contact">
    <template v-for="(block, idx) in blocks">
      <BlockParagraph
        v-if="block.type === 'Paragraph'"
        :key="`block-${idx}`"
        :content="block.data"
        :odd="idx % 2 !== 0"
      />
      <BlockParagraphPic
        v-if="block.type === 'ParagraphPic'"
        :key="`block-${idx}`"
        :content="block.data"
        :odd="idx % 2 !== 0"
      />
      <BlockTimeline
        v-if="block.type === 'Timeline'"
        :key="`block-${idx}`"
        :content="block.data"
      />
      <BlockHero
        v-if="block.type === 'Hero'"
        :key="`block-${idx}`"
        :content="block.data"
      />
      <Youtube
        v-if="block.type === 'Youtube'"
        :key="`block-${idx}`"
        :content="block.data"
      />
      <Gallery
        class="blocked"
        v-else-if="block.type === 'Gallery'"
        :key="`block-${idx}`"
        :block-content="block.data"
      />
    </template>

    <form v-if="!success" @submit.prevent.stop="handleSubmit" novalidate>
      <div class="group">
        <h3>Nehmen Sie Kontakt auf</h3>
      </div>
      <div class="group">
        <input
          id="firstname"
          type="text"
          placeholder="Vorname *"
          v-model="form.firstname"
          :class="{ error: $v.form.firstname.$error }"
        />
        <input
          id="lastname"
          type="text"
          placeholder="Nachname *"
          v-model="form.lastname"
          :class="{ error: $v.form.lastname.$error }"
        />
      </div>
      <div class="group">
        <input
          id="email"
          type="email"
          placeholder="Email Adresse *"
          v-model="form.email"
          :class="{ error: $v.form.email.$error }"
        />
      </div>
      <div class="group">
        <textarea id="message" placeholder="Mitteilung" v-model="form.inquiry"/>
      </div>
      <div class="group">
        <button type="submit">Senden</button>
      </div>
    </form>
    <div v-else class="form-success">
      <h3>Herzlichen Dank!</h3>
      <p>Wir nehmen baldmöglichst Kontakt mit Ihnen auf.</p>
    </div>
  </main>
</template>

<script>
  import { required, email } from 'vuelidate/lib/validators';
  import BlockParagraph from '@/components/ui/BlockParagraph';
  import BlockParagraphPic from '@/components/ui/BlockParagraphPic';
  import BlockTimeline from '@/components/ui/BlockTimeline';
  import BlockHero from '@/components/ui/BlockHero';
  import Youtube from '@/components/ui/Youtube';
  import Gallery from '@/components/ui/Gallery';

  export default {
    name: 'Contact',
    components: {
      BlockHero,
      BlockTimeline,
      BlockParagraphPic,
      BlockParagraph,
      Youtube,
      Gallery,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {},
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        form: {
          firstname: null,
          lastname: null,
          email: null,
          inquiry: null,
          time: null,
        },
        submitting: false,
        success: false,
      };
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      blocks() {
        return this.$b.data?.content?.blocks || [];
      },
    },
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    validations: {
      form: {
        firstname: { required },
        lastname: { required },
        email: { required, email },
      },
    },
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    mounted() {
    },
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
      async handleSubmit() {
        this.$v.$touch();
        if (!this.$v.$invalid && !this.submitting) {
          const form = JSON.parse(JSON.stringify(this.form));
          form.time = Math.floor(Date.now() / 1000);

          this.submitting = true;
          const response = await this.$b.api.post('contact/entries', null, form);
          if (response.status === 200) {
            this.success = true;
            this.submitting = false;
          }
        } else {
          this.$nextTick(() => {
            const errorField = this.$el.querySelector('.error');
            errorField.focus();
          });
        }
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.view.contact {
  @include max-width-constraints;
  padding-top: 40px;
  width: 100%;

  @include screen-mobile {
    padding-top: 40px;
  }

  & > .info {
    position: relative;
    display: inline-block;
    left: 50%;
    transform: translate(-50%, 0);
    background: rgba(255, 255, 255, .85);
    padding: 20px 50px 20px 30px;
    box-shadow: 0 0 5px rgba(0, 0, 0, .1);
    opacity: 1;

    & > em {
      position: absolute;
      display: block;
      pointer-events: none;
      width: 50px;
      height: 50px;
      border-color: black;
      border-style: solid;
      border-width: 1px;

      &:first-of-type {
        bottom: -1px;
        left: -1px;
        border-top-width: 0;
        border-right-width: 0;
      }
      &:last-of-type {
        top: -1px;
        right: -1px;
        border-left-width: 0;
        border-bottom-width: 0;
      }
    }

    & > a {
      display: block;
    }
  }

  & > form {
    width: 100%;
    max-width: 700px;
    margin: 0 auto;
    padding: 80px 0;

    @include screen-mobile {
      padding-top: 20px;
    }

    & > .group {
      display: flex;
      gap: 20px;
      margin-bottom: 20px;
      &:last-of-type {
        margin-bottom: 0;
      }

      @include screen-mobile {
        flex-direction: column;
      }

      h3 {
        width: 100%;
        padding: 0;
        margin: 0;
        text-align: center;
        font-size: 2.4rem;
        font-weight: normal;
        white-space: nowrap;

        @include screen-mobile {
          font-size: 2.4rem;
          white-space: normal;
          text-align: left;
        }
      }

      & > input[type=email], & > input[type=text], & > textarea {
        position: relative;
        width: 50%;
        min-height: 56px;
        border: 1px solid black;
        background-color: white;
        font-family: inherit;
        font-size: inherit;
        color: inherit;
        padding: 20px;
        outline: 0;
        transition: outline $default-transition;

        &.error {
          background-color: #ffeeee;
          outline: 1px solid #ff2600;
        }

        @include screen-mobile {
          width: 100%;
        }

        &:focus-within {
          outline: 1px solid black;
        }

        &:only-child {
          width: 100%;
        }
      }

      & > textarea {
        min-height: 226px;
      }

      & > button {
        background-color: white;
        padding: 10px 20px;
        font-family: inherit;
        border: 1px solid black;
        font-size: inherit;
        outline: 0;

        &:focus-within, &:hover {
          outline: 1px solid black;
        }
      }
    }
  }

  & > .form-success {
    width: 100%;
    max-width: 700px;
    margin: 80px auto 80px auto;
    padding: 80px 0;
    border: 1px solid #008000;
    background-color: rgba(0, 128, 0, 0.1);
    text-align: center;

    & > h3 {
      @include font-bold;
      margin-bottom: 16px;
    }
    & > p {
      @include font-light;
    }
  }
}
</style>
